// report.js
// -----------------------------------------------------------------------------
// The one place the app writes to the browser console in a production build.
//
// `no-console` is an error in production (.eslintrc.js), which is right for the
// stray `console.log` a debugging session leaves behind. But a failure caught
// from the ASMX service or Firestore is a different thing: the Thai message a
// user sees says only that something went wrong, and the error object in the
// console is the only thing IT can read when they open the developer tools on
// that user's PC. Deleting those would make every such failure undiagnosable.
//
// So a deliberate report goes through here, and the lint rule keeps meaning
// what it says everywhere else. Do not use this for tracing a normal flow --
// that is exactly the noise the rule exists to keep out.
// -----------------------------------------------------------------------------

function write (level, context, detail) {
  // eslint-disable-next-line no-console
  const log = console[level] || console.log
  if (detail === undefined) log('[delivery] ' + context)
  else log('[delivery] ' + context, detail)
}

// Something failed and was caught: a request, a write, an unexpected state.
export function reportError (context, error) {
  write('error', context, error)
}

// Something unexpected that the code recovered from on its own, such as a
// record that is not where it should be.
export function reportWarning (context, detail) {
  write('warn', context, detail)
}

export default { reportError, reportWarning }
